const action = {
    general: 'Đã xảy ra lỗi khi thực hiện hành động. Vui lòng thử lại sau.',
    sign_in_identifier_changed: 'Hành động này không thể thay đổi định danh đăng nhập dùng cho lượt xác minh này.',
};
export default Object.freeze(action);
